"use client";

import { c as _c } from "react/compiler-runtime";
import type { ProductUnitDTO } from "@/lib/units/types";
type UnitSelectorProps = {
  units: ProductUnitDTO[];
  selectedId: string;
  onChange: (id: string) => void;
  isRTL: boolean;
};

/**
 * Unit chips ("piece" / "stack" / "carton") for the product detail page.
 * Reuses the same pill markup as the plain (non-color) variant-option chips
 * in `VariantSelector` so a unit reads as another choice the customer makes.
 */
export default function UnitSelector(t0) {
  const $ = _c(16);
  const {
    units,
    selectedId,
    onChange,
    isRTL
  } = t0;
  if (units.length === 0) {
    return null;
  }
  const t1 = isRTL ? "\u0627\u0644\u0648\u062D\u062F\u0629" : "Unit";
  let t2;
  if ($[0] !== t1) {
    t2 = <p className="text-sm font-medium text-foreground">{t1}</p>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== isRTL || $[3] !== onChange || $[4] !== selectedId || $[5] !== units) {
    let t4;
    if ($[7] !== isRTL || $[8] !== onChange || $[9] !== selectedId) {
      t4 = unit => {
        const isSelected = unit.id === selectedId;
        const label = isRTL ? unit.name_ar : unit.name_en ?? unit.name_ar;
        return <button key={unit.id} type="button" onClick={() => onChange(unit.id)} aria-pressed={isSelected} className={["min-w-12 px-4 py-2 rounded-lg text-sm font-medium border transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-1", isSelected ? "bg-primary text-primary-foreground border-primary" : "bg-background text-foreground border-border hover:border-primary"].join(" ")}>{label}</button>;
      };
      $[7] = isRTL;
      $[8] = onChange;
      $[9] = selectedId;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    t3 = units.map(t4);
    $[2] = isRTL;
    $[3] = onChange;
    $[4] = selectedId;
    $[5] = units;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[11] !== t3) {
    t4 = <div className="flex flex-wrap gap-2">{t3}</div>;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t2 || $[14] !== t4) {
    t5 = <div className="flex flex-col gap-2.5">{t2}{t4}</div>;
    $[13] = t2;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}